import React, { useState, useCallback, useEffect } from "react";
import {
  Row,
  Col,
  Pagination,
  Collapse,
  message,
} from "antd";
import {
  CaretRightOutlined
} from "@ant-design/icons";
import axios from "axios";

import PageHeader from "../Layout/PageHeader";
import CargoActivationList from "./CargoActivationList";
import CargoActivationFilters from "./CargoActivationFilters";

const CargoActivation = () => {
  const [loading, setLoading] = useState({
    index: false,
    create: false,
    export: false,
  });
  const [cargoActivations, setCargoActivations] = useState([]);
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 50 });

  const fetchCargoActivations = useCallback(async () => {
    setLoading((prevLoading) => ({ ...prevLoading, index: true }));

    try {
      const params = {
        limit: pagination.limit,
        page: pagination.currentPage,
        ...(filters.search && {
          searchField: filters.searchField,
          search: filters.search,
        }),
        startDate: filters.startDate?.startOf("day")?.toISOString(),
        endDate: filters.endDate?.endOf("day")?.toISOString(),
        ...(filters.status && { status: filters.status }),
      };
      const res = await axios.get("/api/cargo-activations", { params });

      setCargoActivations(res.data.data || []);
      setPagination(res.data.pagination);
    } catch (error) {
      message.error(error.response?.data.message || error.message);
    }

    setLoading((prevLoading) => ({ ...prevLoading, index: false }));
  }, [pagination.currentPage, pagination.limit, filters]);

  useEffect(() => {
    fetchCargoActivations();
  }, [pagination.currentPage, pagination.limit, fetchCargoActivations]);

  return (
    <div>
      <PageHeader
        title="Cargo Activations"
        childRoutes={[
          { path: "/cargo-activations", breadcrumbName: "Cargo Activations" },
        ]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <CargoActivationFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row className="mt-2 mb-2" justify="space-between" align="middle">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>

      <CargoActivationList
        cargoActivations={cargoActivations}
        loading={loading.index}
      />

      <Pagination
        total={pagination?.totalSize}
        pageSize={pagination?.limit}
        onChange={(currentPage, limit) => {
          setPagination({ ...pagination, limit, currentPage });
        }}
        current={pagination.currentPage}
      />
    </div>
  );
};

export default CargoActivation;
